import { useDashboardFeatureFlags } from '@components';
import { Select } from '@fourthwall/components';
import React, { useMemo } from 'react';
import { useReportType } from '../../../../hooks/useReportType';
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams';
import * as S from './ChartEntityGroupSelect.styled';
export const ChartEntityGroupSelect = () => {
    const { reportType } = useReportType();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { queryParams: { chartEntity: [chartEntityGroupParam, setChartEntityGroupParam], }, } = useAnalyticsParams();
    const options = useMemo(() => {
        const options = [
            { label: 'All', value: 'ALL' },
            { label: 'Orders', value: 'ORDERS' },
            { label: 'Donations', value: 'DONATIONS' },
            { label: 'Twitch Gifts', value: 'GIVEAWAY' },
            { label: 'Giveaway links', value: 'GIFTS_ON_CREATOR_COST' },
        ];
        if (dashboardFeatureFlags.memberships.enabled) {
            options.push({ label: 'Memberships', value: 'SUBSCRIPTIONS' }, { label: 'Memberships tip', value: 'MEMBERSHIP_TIP' });
        }
        if (dashboardFeatureFlags.memberships.enabled) {
            options.push({ label: 'Memberships locked message', value: 'MEMBERSHIP_LOCKED_MESSAGE' });
        }
        return options;
    }, [dashboardFeatureFlags.memberships.enabled]);
    if (reportType !== 'orders' && reportType !== 'profit')
        return null;
    return (React.createElement(S.Container, null,
        React.createElement(Select, { label: "Type", options: options, size: "medium", value: chartEntityGroupParam || options[0].value, onValueChange: (value) => setChartEntityGroupParam(value) })));
};
